/* 订单详情---付款阶段组件 */
<template>
  <div class="payment-stage">
    <Table
      v-if="orderStageList"
      :columns="columns"
      :data="orderStageList"
      disabled-hover
      tooltip
    >
      <template slot-scope="{ row, index }" slot="stgTitle">
        <div>
          <Tooltip
            v-if="
              additionList &&
              additionList.length > 0 &&
              index + 1 === orderStageList.length
            "
            content="（注：“增减项”金额为订单“补差价”和“退款”总计金额）"
            max-width="500"
            theme="light"
            placement="right"
          >
            <span>{{ row.stgTitle }}</span>
            <p class="additionAmount">（含增减项）</p>
          </Tooltip>
          <div v-else>
            <span>{{ row.stgTitle }}</span>
          </div>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="paymentAmount">
        <div>
          <p>
            <span>{{ row.paymentAmount | currency("¥", "2") }}</span>
          </p>
          <Tooltip
            v-if="
              additionList &&
              additionList.length > 0 &&
              index + 1 === orderStageList.length
            "
            content="（注：“增减项”金额为订单“补差价”和“退款”总计金额）"
            max-width="500"
            theme="light"
            placement="right"
          >
            <p
              class="additionAmount-price"
              @click="openAdditionAmountDialog(row.additionAmount)"
            >
              <span v-if="row.additionAmount > 0">{{
                row.additionAmount | currency("+¥", "2")
              }}</span>
              <span v-else>{{
                row.additionAmount || 0 | currency("¥", "2")
              }}</span>
            </p>
          </Tooltip>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actualAmount">
        <div>
          <p>{{ row.actualAmount || 0 | currency("¥", "2") }}</p>
        </div>
      </template>
      <template slot-scope="{ row }" slot="paymentState">
        <div>{{ statusText(row.paymentState) }}</div>
      </template>
      <template slot-scope="{ row }" slot="comment">
        <Tooltip
          style="width: 300px"
          v-if="row.comment"
          max-width="600"
          theme="light"
          :content="row.comment"
          placement="top"
        >
          <p class="ellipsis">{{ row.comment }}</p>
        </Tooltip>
        <p v-else>--</p>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
          v-if="
            ordersDetail.payInfomation &&
            row.stgNo === ordersDetail.activeStage &&
            ordersDetail.stateId > 50
          "
          @click="stageBtnActive(ordersDetail, row)"
          style="margin-left: 10px"
          class="red-btn"
          size="small"
          type="primary"
          >{{ ordersDetail.payInfomation.buttonWord }}</Button
        >
      </template>
    </Table>
    <additionAmount-dialog
      ref="additionAmountDialog"
      :additionList="additionList"
      :totalPrice="totalPrice"
    ></additionAmount-dialog>
  </div>
</template>

<script>
import additionAmountDialog from "@/components/dialogs/additionAmount.vue";
export default {
  data() {
    return {
      columns: [
        {
          title: "付款阶段",
          slot: "stgTitle",
          align: "center",
          width: 150,
        },
        {
          title: "应付金额",
          align: "center",
          slot: "paymentAmount",
          width: 200,
        },
        {
          title: "实付金额",
          align: "center",
          slot: "actualAmount",
          width: 150,
        },
        {
          title: "阶段支付状态",
          align: "center",
          slot: "paymentState",
          width: 200,
        },
        {
          title: "内容",
          align: "center",
          slot: "comment",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width: 200,
        },
      ],
      totalPrice: "",
    };
  },
  components: { additionAmountDialog },
  props: {
    ordersDetail: {
      type: [String, Object],
      default: "",
    },
    orderStageList: {
      type: [String, Array],
      default: "",
    },
    /* 增减项费用明细 */
    additionList: {
      type: [String, Array],
      default: "",
    },
  },
  methods: {
    /* 订单显示状态 */
    statusText(paymentState) {
      if (!paymentState) return false;
      switch (paymentState) {
        case 50:
          return "未开始";
          break;
        case 100:
          return "等待您付款";
          break;
        case 200:
          return "已发起收款申请，待审核";
          break;
        case 300:
          return "已付清";
          break;
        case 400:
          return "部分付款";
          break;
        default:
          return "---";
      }
    },

    /* 打开增减项详情弹框 */
    openAdditionAmountDialog(totalPrice) {
      if (!this.additionList || this.additionList.length === 0) return false;
      this.totalPrice = totalPrice;
      this.$refs.additionAmountDialog.open();
    },

    /* 阶段按钮 */
    stageBtnActive(itemInfo, item) {
      if (itemInfo.activeStage === 1 && itemInfo.stateId === 50) {
        /* 确认合同 */
        this.$emit("submitBtnHandleStage", 3);
      } else if (
        item.paymentState === 100 ||
        item.paymentState === 200 ||
        item.paymentState === 400
      ) {
        /* 付款 */
        this.$emit("submitBtnHandleStage", 2);
      } else {
        /* 下载合同 */
        this.$emit("submitBtnHandleStage", "download", "file");
      }
    },
  },
};
</script>  

<style lang="scss">
.payment-stage {
  .ivu-table-wrapper .ivu-table th {
    background: #fff !important;
  }
  .ivu-table:before {
    background-color: #fff;
  }
  .ivu-table-wrapper .ivu-table tr .ivu-table-cell {
    padding: 15px 0px !important;
  }
  .ivu-table th,
  .ivu-table td {
    border-top: 1px solid #f1efef !important;
  }
  .additionAmount {
    color: #707070;
  }
  .additionAmount-price {
    span {
      color: #e56a69;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>